import { AppBar, AppBarProps } from '@mui/material'
import React from 'react'

export type WcAppbarProps = AppBarProps

export const WcAppbar = ({children,...props}: WcAppbarProps) => (
    <AppBar {...props}>{children}</AppBar>
  )